export enum UyapTebligatEvrakTuru {
    icra_odeme_emrinin_teblige_cikartilmasi = 8,
    kiymet_takdirinin_teblige_cikartilmasi = 9,
    yuz_uc_davetiyesinin_teblige_cikartilmasi = 10,
    bakiye_borc_muhtirasinin_teblige_cikartilmasi = 11,
    yenileme_emrinin_teblige_cikartilmasi = 12,
    taahhudu_kabul_muhtirasi_tebligi = 40,
    temlik_bilgisinin_bildirilmesi = 41
}